import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

export default {
  namespaced: true,
  state () {
    return {
      name: undefined,
      telephone: undefined,
      fax: undefined,
      email: undefined,
      department: undefined,
      departmentCode: undefined,
      accountAssignedId: undefined
    }
  },
  actions,
  getters,
  mutations
}
